<template>
    <b-container class="bv-example-row">
        <div v-show="stackview == 'main'">
<!--            <b-row class="my-1 justify-content-md-center">-->
<!--                <b-col sm="10">-->
<!--                    <h3>Informações de ativação de usuário [B]</h3>-->
<!--                </b-col>-->
<!--            </b-row>-->
<!--            <hr>-->
            <!--            <ValidationObserver ref="formmain1" v-slot="{ passes }">-->
            <ValidationObserver ref="formmain_1" v-slot="{ invalid }">
                <b-form>
                    <b-row class="my-1 justify-content-md-center">
                        <b-col sm="9">
                            <ValidationProvider rules="required|min:14|max:14|cpf" name="CPF Associado"
                                                v-slot="{ valid, errors }">
                                <label for="feedback-CPF">Usuário</label>
                                <b-input
                                        required
                                        placeholder="Entre com o CPF do associado!"
                                        v-model="ItemAtual.CPF"
                                        v-mask="['###.###.###-##']"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-CPF"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row class="my-1 justify-content-md-center">
                        <b-col sm="9">
                            <ValidationProvider rules="required|min:4|max:24" name="Senha"
                                                v-slot="{ valid, errors }">
                                <label for="feedback-senha">Senha</label>
                                <b-input
                                        required
                                        placeholder="Entre com o senha!"
                                        type="password"
                                        v-model="ItemAtual.senha"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-senha"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row class="my-1 justify-content-md-center mt-5 mr-2">
                        <b-col sm="10">
                            &nbsp;
                        </b-col>
                        <b-col sm="2">
                            <b-button variant="primary" @click="validarLogin" :disabled="invalid">Login</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </ValidationObserver>
        </div>
        <div v-show="stackview == 'usuarioinvalido'">
            <p>Usuário/Senha invalido</p>
            <b-button variant="primary" @click="stackview='main'">Voltar</b-button>
            <!--            <lista-users-wordpress></lista-users-wordpress>-->
        </div>
        <input type="hidden" :value="cpf">
<!--        <pre>-->
<!--            {{cpf}}-->

<!--            {{ItemAtual}}-->
<!--        </pre>-->
    </b-container>

</template>

<script>
    import { ValidationObserver, ValidationProvider } from "vee-validate";

    export default {
        props     : {
            cpf: String,
        },
        components: {
            ValidationObserver,
            ValidationProvider
        },
        name      : "wordpressauth",
        data () {
            return {
                // passes   : false,
                stackview: 'main',
                ItemAtual: {
                    CPF  : this.cpf,//'969.882.530-41',
                    senha: ''

                }
            }
        },
        watch     : {
            cpf: {
                handler  : function () {
                    this.ItemAtual.CPF = this.cpf;
                },
                immediate: true,
            },
        },
        methods   : {
            validarLogin () {
                console.log('validarLogin', this.ItemAtual);
                let m = this;
                //https://logaretm.github.io/vee-validate/guide/forms.html#programmatic-access-with-refs
                m.$refs.formmain_1.validate().then(success => {
                    try {
                        axios({
                                  method      : 'post',
                                  // url         : '/getValidarCnpj.php',
                                  responseType: 'json',
                                  params      : {
                                      op: 'authdata',
                                      ...m.ItemAtual,
                                  }
                              })
                            .then(function (response) {
                                // m.dt = response.data;
                                if (response.data['valid']) {
                                    m.$emit('finalizado', response.data);
                                }
                                else {
                                    m.stackview = 'usuarioinvalido';
                                }
                            });
                    } catch (e) { }
                    finally { }
                });
            }
        }
    }
</script>

<style scoped>

</style>
